export { registerFlexLayoutPlugin } from '../plugins/builtin-plugin/flex-layout-plugin';
